import { Component, OnInit } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

import { MENU } from '@core/constants/menu';
import { CategoryMenu } from '@core/models/enum/category-menu.enum';
import { IMenu } from '@core/models/interfaces/menu.interface';
import { environment } from '@env/environment';
import { ChatbotService } from './shared/services/chatbot.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  public menu: IMenu[] = [];
  protected menuFooter: IMenu[] = [];
  protected isProduction!: boolean;

  constructor(
    private library: FaIconLibrary,
    private chatbotService: ChatbotService,
    private cookieService: NgcCookieConsentService
  ) {
    this.isProduction = !!environment.production;
  }

  ngOnInit() {
    this.chatbotService.hideChat();
    this.registrarIcones();
    this.getMenu();
  }

  registrarIcones() {
    this.library.addIconPacks(fab);
  }

  getMenu() {
    this.menu = MENU;
    this.menuFooter = this.menu.filter(
      item => item.category === CategoryMenu.PRINCIPAL
    );
  }
}
